export default {
  pxBreakPoint: 1199,
  pxBreakPointNext: 1200,
  pxMobileBreakPoint: 799,
  pxMobileBreakPointNext: 800,
  GENERAL_SECTION: "GENERAL",
  INVENTORY_SECTION: "INVENTORY",
  MODIFIERS_SECTION: "MODIFIERS",
  PRICES_PER_VARIANT_SECTION: "PRICESPERVARIANT",
  ADVANCED_INVENTORY_SECTION: "ADVANCED_INVENTORY",
  MIX_AND_MATCH_SECTION: "mix&match",
  EMPLOYEES_SCHEDULE: "EMPLOYEES_SCHEDULE",
};
